<!-- =========================================================================================
  File Name: index.vue (page circulaire pour administrateur)
  Description: Ajout de nouveau circulaire (ajouter le lien) && Envoi de notification pour tous les clients && consulter le lien de circulaire .
========================================================================================== -->

<template>

<div id="list-circulaire">

    <vs-popup class="holamundo" title="Ajouter circulaire" :active.sync="popupActiv">
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="w-full mt-4">
                    <label class="mt-2">Titre circulaire</label>
                    <div class="mt-2">
                        <vs-input class="w-full" icon-pack="feather" v-model="title" icon="icon-info" />
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="w-full mt-4">
                    <label class="mt-2">Lien circulaire</label>
                    <div class="mt-2">
                        <vs-input class="w-full" icon-pack="feather" v-model="lienCirculaire" icon="icon-info" />
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="vx-row">
            <div class="vx-col w-full">
                <div class="w-full mt-4">
                    <label class="mt-2">Ajoutée par</label>
                    <div class="mt-2">
                        <vs-input disabled="true" label-placeholder="administrateur" class="w-full" icon-pack="feather" v-model="creePar" icon="icon-info" />
                    </div>
                </div>
            </div>
        </div>-->
        <!--<div class="vx-row">
            <div class="vx-col w-full">
                <div class="w-full mt-4">
                    <label class="mt-2">Etat</label>
                    <div class="mt-2">
                        <vs-input disabled="true" label-placeholder="0" class="w-full" icon-pack="feather" v-model="etat" icon="icon-info" />
                    </div>
                </div>
            </div>
        </div>-->
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button color="primary" type="gradient" @click="Ajouter" :disabled="DisableAjouter">Ajouter</vs-button>
                </div>
            </div>
        </div>
    </vs-popup>

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="dataList">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                <vs-button class="dd-actions cursor-pointer mr-4 mb-4" type="relief" color="primary" @click="popupActiv=true">Ajouter une circulaire</vs-button>
            </div>
        </div>

        <template slot="thead">
            <vs-th sort-key="Item_No" class="table_head_color">Date</vs-th>
            <vs-th sort-key="Name" class="table_head_color">Titre</vs-th>
            <vs-th sort-key="Name" class="table_head_color">Crée par</vs-th>
            <vs-th sort-key="Year" class="table_head_color" >Lien</vs-th>
            <vs-th sort-key="Year" class="table_head_color">Notifier client</vs-th>           
        </template>

        <template slot-scope="{data}">
            <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td>
                        <p>{{ filterDate(tr.creeLe) }}</p>
                    </vs-td>
                    <vs-td>
                        <p>{{ tr.title }}</p>
                    </vs-td>
                    <vs-td>
                        <p>{{ tr.creePar }}</p>
                    </vs-td>
                    <!--  ******************************* icone vue pour consulter le lien de la circulaire  ****************************** -->
                    <vs-td class="whitespace-no-wrap">
                        <button class="button"  @click="openUrl(tr.lienCirculaire)"> <feather-icon icon="EyeIcon" class="feather-eye" svgClasses="w-3 h-3" /></button>
                    </vs-td>
                    <!--  ******************************* Bouton pour envoyer une notification aux clients  ****************************** -->
                    <vs-td class="whitespace-no-wrap">
                      <button  v-bind:class="classObject(tr.etat)" autofocus :disabled="disableButton(tr.etat)"  @click="checkSendModele(tr.id)"> <feather-icon icon="SendIcon" class="feather-send" svgClasses="w-3 h-3" /></button>
                    </vs-td>
                </vs-tr>
            </tbody>
        </template>
    </vs-table>

</div>
</template>
<script>
import circulaireService from "@/http/requests/circulaire/index.js";
import notificationService from "@/http/requests/notification/index.js";
import { id } from 'vuejs-datepicker/src/locale';
import moment from 'moment';
export default {
    data() {
        return {
            imgView: require("@/assets/images/portrait/small/eye.svg"),
            itemsPerPage: 10,
            dataList: [],
            circulaire:[],
            fileContent:null,
            popupActiv: false,
            title: "",
            lienCirculaire: "",
            creePar: "",
            etat: ""
        }
    },
    watch: {
        dataList: function () {
            this.$vs.loading.close("#list-circulaire > .con-vs-loading");
        }
    },
    methods: {
        classObject(etat){
            if(etat === 0){
                return "button";
            }else{
                return "butttonActive"
            }
        },
        openUrl(url){
            window.open(url, '_blank');
        },
        Ajouter(){
            this.$vs.loading();
            var body;
            body = {
                title : this.title.substring(0,250),
                lienCirculaire : this.lienCirculaire.substring(0,250),
                creePar : "administrateur",
                etat : 0
            }
            try{
                circulaireService.AddNewCirculaire(body).then(response => {
                this.$vs.loading.close();
                    this.popupActiv = false
                    this.title = "";
                    this.lienCirculaire = "";
                    this.loadData();
                    this.$swal.fire({
                        position: "absolute",
                        icon: "success",
                        title: "Vous avez ajouté une circulaire.",
                        showConfirmButton: true,
                        timer: 2500
                    });    
                }).catch(error => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        time: 10000,
                        title: "Erreur d'ajout de circulaire",
                        text: error.data,
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circles"
                    });
                })
            }catch{
                this.$vs.loading.close();
                this.$vs.notify({
                    time: 10000,
                    title: "Erreur Erreur Erreur",
                    text: "Erreur",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circles"
                });
            }         
            
        },
        disableButton(etat){
            if (etat == 0){
                return false;
            }
            else {
                return true;
            }
        },
        findCirculaire(id){
            try {           
                circulaireService.findCirculaire(id).then(response => {
                    this.circulaire = response.data                 
                    //downloadjs(this.circulaire.content,this.circulaire.title,"application/pdf")
                })
                this.$vs.loading.close("#list-circulaire > .con-vs-loading");
            } catch {
                this.$vs.loading.close();
                this.$vs.loading.close("#list-circulaire > .con-vs-loading");
                this.$vs.notify({
                    time: 10000,
                    title: "Erreur s'est produite l'ors de la récupération de données",
                    text: "Erreur",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circles"
                });
            }
        },
        filterDate(value) {
             if (value) {
                 return moment(String(value)).format('DD/MM/YYYY HH:mm')
             }
        },
        confirmer() {
            this.$vs.loading();
            console.log(this.$refs.fileInput.filesx)
            const circulaireData = {
                file: this.$refs.fileInput.filesx[this.$refs.fileInput.filesx.length - 1],
                title: this.title
            }
            try {
                circulaireService.Add(circulaireData).then(response => {
                    this.$vs.loading.close();
                    this.popupActiv = false
                    this.title = ""
                    this.$swal.fire({
                        position: "absolute",
                        icon: "success",
                        title: "Vous avez importer.",
                        showConfirmButton: true,
                        timer: 2500
                    });
                    this
                    console.log(response)
                }).catch(error => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        time: 10000,
                        title: "Erreur s'est produite l'ors de la validation",
                        text: error.data,
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circles"
                    });
                })
            } catch {
                this.$vs.loading.close();
                this.$vs.notify({
                    time: 10000,
                    title: "Erreur s'est produite l'ors de la validation",
                    text: "Erreur",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circles"
                });
            }
        },
         loadData() {
            try {
                circulaireService.getAll().then(response => {
                    this.dataList = response.data
                })
                this.$vs.loading.close("#list-circulaire > .con-vs-loading");
            } catch {
                this.$vs.loading.close();
                this.$vs.loading.close("#list-circulaire > .con-vs-loading");
                this.$vs.notify({
                    time: 10000,
                    title: "Erreur s'est produite l'ors de la récupération de données",
                    text: "Erreur",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circles"
                });
            }
        },
        successUpload() {
            this.$vs.notify({
                color: 'default',
                title: 'Upload Success',
                text: 'Lorem ipsum dolor sit amet, consectetur'
            })
        },
        checkSendModele(id) {
            this.id = id;
            this.$vs.dialog({
                type: "confirm",
                color: 'success',
                title: `Envoi de notification`,
                text: "Confirmation d'envoi de notification",
                acceptText: "Envoyer",
                cancelText: "Annuler",
                accept:this.sendNotification,
                parameters: [id]               
            });
        },
          sendNotification: function(id){
            this.$vs.loading(); 
            notificationService.sendNotification(id).then(response => {
                this.loadData();
                
            }).then(response => {
                this.$vs.loading.close();
                this.$swal.fire({
                    position: "absolute",
                    icon: "success",
                    title: "Notification envoyée avec succès",
                    showConfirmButton: true,
                    timer: 2500
                });
            })
        }
    },
    computed: {
        DisableConfirmer() {
            return this.title == ""
        }
        
    },
     created() {
        if (this.$store.state.AppActiveUser.id != '') {
             this.loadData();
        } else {
            this.$store.subscribe(mutation => {
                if (mutation.type === "UPDATE_USER_INFO") {
                   this.loadData();
                }
            });
        }
    },
    mounted() {
        this.isMounted = true;
        this.$vs.loading({
            background: this.backgroundLoading,
            // color: this.colorLoading,
            type: 'radius',
            container: "#list-circulaire",
            scale: 0.45,
            clickEffect: true
        });
    }
}
</script>

<style lang="scss">

#list-circulaire {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000000;
.buttonActive {
  background: rgb(255, 255, 255);
  border-bottom-width: 0px;
  padding: 4px;
}
.button {
  background-color:rgb(40, 199, 111);
  color:white;
  cursor: pointer;
  border-color: aliceblue;
  border-bottom-width: 0px;
  padding: 4px;
}
    .vs-table {
        border-collapse: separate;
        // border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
            box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05);

            td {
                align-items: center;
                justify-content: center;
                text-align: center;
                vertical-align: middle;

                &:first-child {
                    border-top-left-radius: 0.5rem;
                    border-bottom-left-radius: 0.5rem;
                }

                &:last-child {
                    border-top-right-radius: 0.5rem;
                    border-bottom-right-radius: 0.5rem;
                }

                &.img-container {
                    span {
                        display: flex;
                        justify-content: flex-start;
                    }

                    .product-img {
                        height: 110px;
                    }
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 5;
                padding-bottom: 5;
                color: "primary";
                background: #002b5c;
                justify-content: center;

                .vs-table-text {
                    //text-transform: uppercase;
                    font-weight: 600;
                    color: white;
                    justify-content: center;
                }
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .product-name {
        max-width: 23rem;
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        >span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search {
            padding-top: 0;

            .vs-table--search-input {
                padding: 0.9rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }
}
</style>
